:host {
  display: block;
  --padding: 16px;
  --border-color: #d9dbe2;
  position: relative;
}

h3 {
  font-size: 2.4rem;
  @include font-weight(500);
  letter-spacing: 0.025rem;
  line-height: 1.3;
  color: var(--o2-black, #{$black});
  margin: 0 0 12px 0;
}

p {
  font-size: 1.6rem;
  @include font-weight(400);
  line-height: 1.3;
  margin: 0 0 12px 0;
  color: var(--o2-black, #{$black});
}

.box {
  padding: var(--padding);
  background: var(--background);
  border-radius: var(--border-radius, #{$border-radius});
  height: 100%;

  .box__heading {
    display: inline-flex;
  }

  &.box--image {
    background-repeat: no-repeat;
    background-position: 94%;
    background-size: 28%;

    @media (min-width: 768px) {
      background-position: 96%;
      background-size: auto;
    }

    .box__content {
      width: 50%;
    }
  }
}

.box--border {
  border: 1px solid var(--border-color, #{$gray-light});

  &:hover {
    border: 1px solid var(--border-color-hover, #{$gray-light});
  }
}

.box--white {
  --background: #fff;
}

.box--gray {
  --background: #f1f4f7;
}

.box--blue-light {
  --background: var(--o2-blue-action-light, #{$blue-action-light});
}

.box--red-light {
  --background: var(--o2-red-light, #{$red-light});
}

.box--green-light {
  --background: var(--o2-green-light, #{$green-light});
}

.box--orange-light {
  --background: var(--o2-orange-light, #{$orange-light});
}

.box--purple-light {
  --background: var(--o2-purple-light, #{$purple-light});
}
